import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {
  private baseUrl: string | undefined;
  private maintenanceSchedule$ = new BehaviorSubject<any | null>(null); // Cache for the maintenance schedule

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiUrl;
  }

  getMaintenanceSchedule(): Observable<any> {
      // If the cache is empty, fetch the data from the server
      return this.http.get(this.baseUrl + 'api/WebsiteSettings/GetMaintenanceSchedule')
  }

  // Getter for the current value of the maintenance schedule
  getCachedMaintenanceSchedule(): any {
    return this.maintenanceSchedule$.value;
  }
}
